export const EDITOR_DANGER_COLOR = '#F69054';
export const EDITOR_DANGER_TEXT_COLOR = '#A33B00';
